import '../css/main.css';

import './menu.js';
import './coreVitals.js';
import './dataLayers.js';
import './locationsDropdown.js';
import './locationsServiceToggle.js';



const initializeDynamicImports = () => {
	const splideTargets = document.querySelectorAll('.splide');
	if (splideTargets.length > 0) {
		import(/* webpackChunkName: "splide" */ './splide.js').catch((error) => {
			console.warn('Failed to load splide carousel module:', error);
		});
	}

	const projectFilter = document.querySelector('.block-project-archive__filter-list');
	if (projectFilter) {
		import(/* webpackChunkName: "projectFilter" */ './projectFilter.js').catch((error) => {
			console.warn('Failed to load project filter module:', error);
		});
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initializeDynamicImports, { once: true });
} else {
	initializeDynamicImports();
}